import { useContext, useEffect } from 'react';
import IsUsingPlanningViewContext from '@/lib/contexts/IsUsingPlanningViewContext';
import ToggleButtonTooltip from './ToggleButtonTooltip';
import HeaderActionIconButton from '../HeaderActionIconButton';
import {
  DateRange as PlanningIcon,
  ViewColumn as KanbanBoardIcon,
} from '@mui/icons-material';
import * as Sentry from '@sentry/react';

const PlanningViewToggleButton = () => {
  const [isUsingPlanningView, setIsUsingPlanningView] = useContext(
    IsUsingPlanningViewContext,
  );

  useEffect(() => {
    if (isUsingPlanningView) {
      Sentry.captureMessage('[0000] Planning view open.');
    }
  }, [isUsingPlanningView]);

  return (
    <ToggleButtonTooltip isUsingPlanningView={isUsingPlanningView}>
      <HeaderActionIconButton
        onClick={() => setIsUsingPlanningView(!isUsingPlanningView)}
      >
        {isUsingPlanningView ? <KanbanBoardIcon /> : <PlanningIcon />}
      </HeaderActionIconButton>
    </ToggleButtonTooltip>
  );
};

export default PlanningViewToggleButton;
